import type { PropsWithChildren } from 'react'

import IconLoading from '@/assets/icons/icon-loading.svg'
import { RefreshIcon } from '@/assets/icons/icon-refresh'
import { Button } from '@/components/ui/button.tsx'
import { useIsDarkTheme } from '@/utils/useTheme'

interface Props {
  onRefresh: () => void
  isFetching: boolean
  isDisabled?: boolean
}

export const WithRefresher = ({
  children,
  onRefresh,
  isFetching,
  isDisabled,
}: PropsWithChildren<Props>) => {
  const isDark = useIsDarkTheme()

  return (
    <div className="flex gap-2 text-secondary-500">
      {children}
      <Button
        id="date"
        variant="ghost"
        className="flex w-full items-center justify-start gap-2 border bg-card px-3 text-left font-normal text-title"
        disabled={isFetching || isDisabled}
        onClick={onRefresh}
      >
        {isFetching && (
          <IconLoading className="h-4 w-4 animate-spin text-secondary-300" />
        )}
        {!isFetching && (
          <RefreshIcon arrowColor={isDark ? '#FFFFFF' : '#3B4056'} />
        )}
      </Button>
    </div>
  )
}
